import { connect } from "react-redux";
import AddressUpdateWindow from "../components/AddressUpdateWindow";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    ticketUpdating: Ticket.updating.loading,
    ticketUpdatingError: Ticket.updating.err,

    countryListLoading: Dimension.Country.fetching.loading,
    countryList: Dimension.Country.countryList,

    //Misc
    language: Misc.Settings.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AddressUpdateWindow);
